/* eslint-disable max-lines */
/* eslint-disable max-len */

export function ContentLocaleFr() {
  return (
    <>
      <div>
        <p className="page-title">
          Politique de protection des données du portail Web de robotique
        </p>
        <h2 className="heading-title">
          I. Nom et adresse du contrôleur et du délégué à la protection des
          données
        </h2>

        <p className="my-20">Nom et coordonnées du contrôleur des données :</p>
        <p>Kärcher NV</p>
        <p>Kees Wagtmans (directeur)</p>
        <p>Boomsesteenweg 939,</p>
        <p>2610 Wilrijk</p>
        <p>Tel.: 03 340 08 00</p>
        <p>
          <a href="mailto:info@be.kaercher.com">info@be.kaercher.com</a>
        </p>

        <p className="my-10">
          (Ci-après : Kärcher) procèdera conformément aux dispositions légales
          relatives à toutes les opérations de traitement des données (par
          exemple, la collecte, le traitement et la transmission).
        </p>

        <p className="my-10">
          La présente politique de confidentialité vous donne un aperçu des
          types de données collectées sur et par le biais de notre portail web,
          à savoir&nbsp;
          <a
            href="https://kira-webportal.ipp.kaercher.com/"
            target="_blank"
            rel="noreferrer noopener">
            https://kira-webportal.ipp.kaercher.com/
          </a>
          &nbsp;(ci-après dénommé plateforme), de la manière dont elles sont
          traitées, des mesures de sécurité prises par Kärcher pour protéger vos
          données et de la manière d&apos;exercer vos droits.
        </p>

        <p className="my-10">
          Pour toute question concernant la protection des données ainsi que vos
          droits en tant que personne concernée veuillez contacter le délégué à
          la protection des données chez Kärcher à l&apos;adresse suivante :
        </p>

        <p>Kärcher SA</p>
        <p>Délégué à la protection des données</p>
        <p>Boomsesteenweg 939,</p>
        <p>2610 Wilrijk</p>
        <p>
          <a href="mailto:dpo@be.kaercher.com">dpo@be.kaercher.com</a>
        </p>
      </div>

      <div className="mt-40">
        <h2>II. Informations générales concernant le traitement des données</h2>

        <h3>
          1. Champ d&apos;application du traitement des données à caractère
          personnel
        </h3>
        <p>
          Sauf indication contraire, nous traitons vos données à caractère
          personnel en tant qu&apos;utilisateur de notre plateforme (ci-après
          dénommé la personne concernée) afin de mettre à disposition et de vous
          fournir une plateforme fonctionnelle et conviviale ainsi que nos
          contenus et services.
        </p>

        <h3>
          2. Fondement juridique du traitement des données à caractère personnel
        </h3>
        <p>
          Dans la mesure où nous obtenons le consentement de la personne
          concernée pour le traitement des données à caractère personnel, c’est
          l&apos;art. 6 (1) point a du Règlement général sur la protection des
          données (RGPD) qui sert de fondement juridique.
        </p>

        <p className="mt-10">
          Si le traitement des données à caractère personnel est nécessaire pour
          l&apos;utilisation de la plateforme, c’est l&apos;art. 6 (1) point b
          du RGPD qui sert de fondement juridique. Il en va de même pour les
          traitements nécessaires à la mise en œuvre de mesures
          précontractuelles.
        </p>
        <p>
          Dans la mesure où le traitement des données à caractère personnel est
          nécessaire pour l&apos;exécution d&apos;une obligation légale à
          laquelle notre entreprise est soumise, c’est l&apos;art. 6 (1) point c
          du RGPD qui sert de fondement juridique.
        </p>

        <p className="mt-10">
          Si le traitement est nécessaire pour protéger un intérêt légitime de
          notre société ou d&apos;une tierce partie, et si les intérêts, les
          droits et libertés fondamentaux de la personne concernée ne
          l&apos;emportent pas sur l’intérêt précédent, c’est l’art. c’est
          l&apos;article 6 (1) point f du RGPD qui sert de fondement juridique
          au traitement.
        </p>

        <h3>3. Effacement des données et durée de stockage</h3>
        <p>
          Sauf disposition contraire, les donnés personnelles seront effacées ou
          bloquées dès que la finalité du stockage n’a plus lieu d’être.
        </p>

        <p className="mt-10">
          En outre, le stockage peut également être appliqué si le législateur
          européen ou national l’a prévu dans les règlementations de l&apos;UE,
          les lois ou autres réglementations auxquelles est soumis le
          contrôleur. Les données seront également bloquées ou effacées si une
          durée de stockage prescrite expire, à moins qu&apos;il ne soit
          nécessaire de conserver les données pour la conclusion ou
          l&apos;exécution d&apos;un contrat.
        </p>
      </div>

      <div className="mt-40">
        <h2>III. Mise à disposition de la plateforme</h2>

        <h3>1. Description et champ d’application du traitement des données</h3>
        <p>
          Chaque fois que notre plateforme est consultée, notre système collecte
          automatiquement des données et informations provenant du système de
          l’ordinateur y ayant accédé.
        </p>

        <p className="mt-10">Les données suivantes sont collectées :</p>

        <ul>
          <li>Le jour et l’heure de la demande</li>
          <li>Le nom du fichier demandé</li>
          <li>L’heure de la dernière connexion</li>
          <li>La page du fichier qui a été demandée</li>
          <li>
            Le statut de l&apos;accès (fichier transféré, fichier non trouvé,
            etc.)
          </li>
          <li>Le navigateur web et le système d’exploitation utilisés</li>
          <li>L’adresse IP entière de l’ordinateur demandeur</li>
          <li>Le volume des données transféré</li>
          <li>
            Les données robotiques, les informations et cartes sur
            l&apos;itinéraire du robot
          </li>
        </ul>

        <p>
          Les donnés sont également stockées dans les fichiers journaux de notre
          système.
        </p>

        <h3>2. Fondement juridique pour le traitement des données</h3>
        <p>
          Le fondement juridique pour le stockage temporaire des données et les
          fichiers journaux est l’art. 6 (1) point f du RGPD.
        </p>

        <h3>3. Finalité du traitement des données</h3>
        <p>
          Le stockage temporaire de l’adresse IP par le système est nécessaire
          pour permettre l’accès de la plateforme à l&apos;ordinateur de
          l&apos;utilisateur. À cette fin, l’adresse IP de l’utilisateur doit
          être stockée pendant toute la durée de la session.
        </p>

        <p className="mt-10">
          Le stockage dans les fichiers journaux assure la fonctionnalité de la
          plateforme. De plus, nous utilisons les données pour optimiser la
          plateforme et pour nous assurer de la sécurité des nos systèmes
          informatiques.
        </p>

        <p className="mt-10">
          Ces objectifs constituent également notre intérêt légitime dans le
          traitement des données conformément à l&apos;art. 6 (1) point f du
          RGPD.
        </p>

        <h3>4. Durée de stockage</h3>
        <p>
          Les données seront effacées dès qu&apos;elles ne seront plus
          nécessaires à la réalisation de la finalité pour laquelle elles ont
          été collectées.
        </p>
      </div>

      <div className="mt-40">
        <h2>IV. Enregistrement sur la plateforme</h2>

        <h3>1. Description et champ d’application du traitement des données</h3>
        <p>
          Afin de pouvoir utiliser la plateforme dans sa totalité et de
          récupérer les données de la machine traitées pour le ou les appareils
          enregistrés respectifs, l&apos;enregistrement sur la plateforme et
          l&apos;enregistrement d&apos;un compte utilisateur sont obligatoires.
        </p>

        <p className="mt-10">
          L&apos;enregistrement d&apos;un compte utilisateur s&apos;effectue par
          le biais d&apos;un compte Kärcher, dans lequel l&apos;utilisateur peut
          choisir un mot de passe qu&apos;il utilisera conjointement avec son
          adresse e-mail (ci-après : données utilisateur). De plus, d’autres
          informations facultatives peuvent être délivrées (par exemple nom et
          coordonnées de la société). Les données sont saisies sur un masque de
          saisie et nous sont transmises et stockées.
        </p>

        <p className="mt-10">
          Les numéros de téléphone et les adresses e-mail peuvent être stockés
          sur la plateforme pour la transmission de messages par SMS ou e-mail
          envoyés depuis un périphérique. Ces données sont enregistrées et
          dénommées opérateurs, où sont stockés le nom, le numéro de téléphone,
          l&apos;adresse électronique et le périphérique à partir duquel les
          messages sont transférés.
        </p>

        <h3>2. Fondement juridique pour le traitement des données</h3>
        <p>
          Le fondement juridique pour le traitement des données à caractère
          personnel est l’exécution du contrat (Article 6 (1) point b du RGPD).
        </p>

        <h3>3. Finalité du traitement des données</h3>
        <p>
          La création d&apos;un compte utilisateur est nécessaire pour
          l&apos;affectation au périphérique ou l&apos;utilisation des fonctions
          fournies. Les données peuvent également être traitées lorsque les
          fonctions choisies par l’utilisateur sont activées.
        </p>

        <h3>4. Durée de stockage</h3>
        <p>
          Lorsque vous créez un compte utilisateur, nous avons l’habitude de
          stocker les données à caractère personnel fournies aussi longtemps que
          vous conservez votre compte utilisateur ou jusqu’à ce que les données
          soient modifiées ou supprimées dans le compte utilisateur.
        </p>

        <p className="mt-10">
          Veuillez noter que la suppression du compte d&apos;utilisateur
          correspondant sur la plateforme peut entraîner la perte de
          l&apos;accès à la plateforme et de l&apos;accès aux données stockées.
        </p>

        <h3>5. Possibilité d’effacement</h3>
        <p>
          Les utilisateurs de la plateforme peuvent à tout moment modifier ou
          effacer les données à caractères personnel qui y sont stockées.
        </p>

        <p className="mt-10">
          Si les données sont nécessaires à l&apos;exécution d&apos;un contrat
          ou à la mise en œuvre de mesures précontractuelles, un effacement
          prématuré des données n&apos;est possible que dans la mesure où les
          obligations contractuelles ou légales ne s&apos;y opposent pas.
        </p>
      </div>

      <div className="mt-40">
        <h2>V. Utilisation de cookies</h2>

        <h3>1. Description et champ d’application du traitement des données</h3>
        <p>
          Notre plateforme utilise des cookies Les cookies sont des fichiers
          texte qui sont stockés dans le navigateur Internet, ou par le
          navigateur Internet sur le système informatique de l’utilisateur.
          Lorsqu’un utilisateur accède à une plateforme, un cookie pourra être
          stocké sur le système informatique de l’utilisateur. Ce cookie
          contient une chaîne de caractères caractéristiques qui permet
          d&apos;identifier exclusivement le navigateur lors d&apos;un nouvel
          accès à la plateforme.
        </p>

        <h3>2. Fondement juridique pour le traitement des données</h3>
        <p>
          Le fondement juridique pour le traitement des données à caractère
          personnel utilisant des cookies techniquement nécessaires est
          l’article 6 (1) point f du RGPD.
        </p>

        <h3>3. Finalité du traitement des données</h3>
        <p>
          L&apos;utilisation de cookies techniquement nécessaires a pour
          finalité de simplifier l&apos;utilisation de la plateforme pour les
          utilisateurs. Certaines fonctions de notre plateforme ne peuvent pas
          être proposées sans l&apos;utilisation de cookies. Les données
          d’utilisateur collectées au moyen de cookies techniquement nécessaires
          ne sont pas utilisées pour créer des profils d’utilisateur. Ces
          objectifs constituent également notre intérêt légitime dans le
          traitement des données à caractère personnel conformément à
          l&apos;art. 6 (1) point f du RGPD.
        </p>

        <h3>4. Possibilité d’opposition</h3>
        <p>
          Les cookies sont stockés sur l’ordinateur de l’utilisateur et transmis
          vers notre site. En tant qu’utilisateur, vous maîtrisez donc
          entièrement l’utilisation de ces cookies. En modifiant les paramètres
          de votre navigateur Internet, vous pouvez désactiver ou restreindre la
          transmission des cookies. Les cookies qui ont déjà été sauvés peuvent
          être effacés à tout moment. Cela peut se faire aussi automatiquement.
          Si les cookies pour notre plateforme sont désactivés, il ne vous sera
          plus possible d’utiliser toutes les fonctionnalités de la plateforme
          dans leur intégralité.
        </p>
      </div>

      <div className="mt-40">
        <h2>VI. Divulgation à des tierces parties</h2>

        <p>
          Au sein du groupe d&apos;entreprises Kärcher, nous échangeons des
          données à caractère personnel dans la mesure où et si cela est
          nécessaire pour le traitement des contrats ou pour la mise en œuvre de
          mesures précontractuelles conformément à l&apos;art. 6 (1) point b du
          RGPD ou s’il y a un intérêt justifié à un transfert intragroupe
          conformément à l&apos;art. 6 (1) point f du RGPD.
        </p>

        <p className="mt-10">
          Outre les cas explicitement mentionnés dans la présente politique de
          protection des données, vos données à caractère personnel ne seront
          transmises à des tiers sans votre consentement préalable explicite
          qu’en cas de requête juridique.
        </p>

        <p className="mt-10">
          Si cela s’avère nécessaire pour clarifier une utilisation illégale ou
          abusive de la plateforme ou pour des poursuites judiciaires, les
          données à caractère personnel seront transmises aux autorités chargées
          de l&apos;application de la loi ou à d&apos;autres autorités publiques
          et, si nécessaire, à des tierces parties lésées. Cette transmission
          n&apos;est toutefois effectuée que s&apos;il existe des indices
          d&apos;un comportement illicite ou abusif. Nous sommes également
          juridiquement tenus de transmettre des informations à certains
          organismes publics à leur demande. Il peut s’agir d’autorités de
          poursuites pénales, d’autorités chargées de poursuivre certaines
          infractions administratives passibles d’amendes, et d’autorités
          financières.
        </p>

        <p className="mt-10">
          Toute divulgation de données à caractère personnel est justifiée par
          le fait que (1) le traitement est nécessaire au respect d&apos;une
          obligation légale à laquelle nous sommes soumis en vertu de
          l&apos;art. 6 (1) point c du RGPD conjointement avec les exigences
          légales nationales pour la divulgation de données aux autorités
          chargées de l&apos;application de la loi, ou (2) nous avons un intérêt
          légitime à divulguer les données aux tiers susmentionnés s&apos;il
          existe des indications d&apos;un comportement abusif ou pour
          l&apos;exécution de réclamations légales et vos droits et intérêts
          dans la protection de vos données à caractère personnel au sens de
          l&apos;art. 6 (1) point f du RGPD ne prévalent pas sur votre intérêt
          légitime.
        </p>

        <p className="mt-10">
          Afin de pouvoir offrir les services sur cette plateforme, il est fait
          appel à des entreprises tierces et à des prestataires de services
          externes. Toutes les compagnies tierces et les prestataires de service
          externes concernés ont été soigneusement sélectionnés comme étant
          processeurs dans le cadre de l’art. 28 (1) du RGPD, contrôlés
          régulièrement et tenus par contrat de traiter toutes les données à
          caractère personnel exclusivement conformément à nos instructions.
        </p>
      </div>

      <div className="mt-40">
        <h2>VII. Transfert de données à des pays tiers </h2>

        <p>
          Sauf indication contraire, les données ne sont transférées à des
          bureaux établis dans des pays hors de l&apos;Union européenne (appelés
          pays tiers) que dans les cas suivants :
        </p>

        <ul>
          <li>
            c’est nécessaire pour l’exécution de vos commandes (par exemple,
            mandats de paiement),
          </li>
          <li>cela est utile pour améliorer le produit,</li>
          <li>le niveau de protection des données suffisant est assuré, ou</li>
          <li>vous nous avez donné votre consentement.</li>
        </ul>
      </div>

      <div className="mt-40">
        <h2>VIII. Sécurité des données</h2>

        <h3>1. Mesures techniques et organisationnelles d’ordre général</h3>
        <p>
          Kärcher a pris un certain nombre de mesures de sécurité afin de
          protéger les informations d’ordre personnel de manière appropriée et
          adéquate. Toutes les données stockées chez Kärcher sont protégées par
          des mesures physiques, techniques et procédurales qui limiteront
          l’accès à ces informations à des personnes spécialement autorisées à
          ces fins, conformément à la présente politique de protection des
          données.
        </p>

        <h3>2. Transmission sécurisée des données</h3>
        <p>
          La transmission des vos données à caractère personnel conjointement à
          un traitement de commande est cryptée selon la technologie de norme
          industrielle Secure Sockte Layer (« SSL »), version de cryptage SSL ou
          selon des technologies similaires.
        </p>

        <h3>3. Mots de passe</h3>
        <p>
          Vous ne transmettrez en aucun cas votre mot de passe pour accéder à
          notre plateforme à des tiers et vous devrez le modifier régulièrement.
          Si vous souhaitez vous déconnecter de votre compte utilisateur, vous
          devrez vous déconnecter et fermer votre navigateur afin d’éviter que
          quelqu’un d’autre obtienne un accès non autorisé.
        </p>
      </div>

      <div className="mt-40">
        <h2>IX. Droits de la personne concernée</h2>

        <h3>1. Droit d’accès</h3>
        <p>
          Conformément à l’art. 15 du RGPD, vous pouvez demander des
          informations sur vos données à caractère personnel que nous traitons.
        </p>

        <h3>2. Droit d’opposition</h3>
        <p>
          Vous avez le droit de vous opposer à ce traitement pour un motif
          valable (voir paragraphe 8).
        </p>

        <h3>3. Droit de rectification :</h3>
        <p>
          Si certaines informations vous concernant ne sont pas (ou plus)
          correctes, vous pouvez en demander la rectification conformément à
          l’art. 16 du RGPD. Si vos données sont incomplètes, vous pouvez
          demander à ce qu’elles soient complétées.
        </p>

        <h3>4. Droit à l’effacement :</h3>
        <p>
          Vous pouvez demander l’effacement de vos données à caractère personnel
          conformément à l’art. 17 du RGPD.
        </p>

        <h3>5. Droit à la limitation du traitement :</h3>
        <p>
          Conformément à l’art. 18 du RGPD, vous avez le droit de demander une
          limitation du traitement de vos données à caractère personnel.
        </p>

        <h3>6. Droit d’introduire une réclamation :</h3>
        <p>
          Si vous estimez que le traitement de vos données à caractère personnel
          viole la loi sur la protection des données, vous avez le droit
          d’introduire une réclamation auprès d&apos;une autorité de contrôle de
          la protection des données de votre choix ou auprès de l&apos;autorité
          de contrôle de la protection des données responsable du contrôleur des
          données, conformément à l&apos;art. 77 (1) du RGPD.
        </p>

        <h3>7. Droit à la portabilité des donnés</h3>
        <p>
          Dans le cas où les conditions de l’art. 20 (1) du RGPD sont remplies,
          vous avez le droit d&apos;obtenir que les données que nous traitons
          automatiquement sur la base de votre consentement ou en exécution
          d&apos;un contrat vous soient remises ou soient remises à des tiers.
        </p>

        <h3>8. Droit d’opposition conformément à l’art. 21 (1) du RGPD :</h3>
        <p>
          Vous avez le droit à tout moment de vous opposer, pour des raisons
          relatives à votre situation particulière, au traitement de vos données
          à caractère personnel qui est effectué sur la base de l&apos;article 6
          (1) point f du RGPD. Le contrôleur des données cessera alors de
          traiter les données à caractère personnel, à moins que ce dernier ne
          démontre des motifs légitimes impérieux pour le traitement qui
          prévalent sur les intérêts, les droits et les libertés de la personne
          concernée, ou pour la constatation, l&apos;exercice ou la défense d’un
          droit en justice.
        </p>
      </div>

      <div className="mt-40">
        <h2>
          X. Modifications de la présente politique de protection des données
        </h2>

        <p>
          Nous maintenons toujours la présente politique de protection des
          données à jour. C’est pourquoi nous nous réservons le droit de la
          mettre à jour et de l&apos;adapter de temps à autre et d&apos;intégrer
          toute modification du traitement ou de l&apos;utilisation de vos
          données. La version actuelle de la politique de protection des données
          est toujours disponible sur la plateforme sous « Politique de
          protection des données ».
        </p>
      </div>
    </>
  );
}
